import React from 'react';
import PackageManagement from '../components/PackageManagement';

const SuperAdminPackages = () => {
  return <PackageManagement />;
};

export default SuperAdminPackages;
